<div class="warning-dialog-header">
    <div class="header__wrapper">
        <div class="warning-title">
            Warning Information @if (!!alert) {<span> - {{ alert.properties.event }}</span>}
        </div>
        <div class="actions">
            @if (!!data && data.length > 1) {
              <button mat-icon-button (click)="showNext()">
                <mat-icon>east</mat-icon>
              </button>
            }
            <button mat-icon-button mat-dialog-close cdkfocusinitial
                aria-label="close">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

</div>

<div mat-dialog-content>
    @if (!!alert) {
      <h2>{{ alert.properties.headline}}</h2>
      <pre>{{ alert.properties.description}}</pre>
    }

    @if (!!alert?.properties?.instruction) {
      <h2>Instruction</h2>
      <pre>{{ alert.properties.instruction}}</pre>
    }
</div>
